import { SupplierReplyResponse, HomeMessageResponse, GetHomeExpenseResponse } from '@gateway.Home'
import { yamadumiApi } from '../yamadumi-api'

/**
 * メッセージ取得
 */
export class GetMessageGateway {
  /**
   *
   * @description 業者回答状況取得
   */
  static getSupplierReply = async () => {
    return await yamadumiApi.get<SupplierReplyResponse>(
      '/api/common/message/supplier/reply'
    )
  }

  /**
   * @description お知らせの取得
   * @param
   * txtKbn: string お知らせの分類を管理
   * arrayTxtKbn: string[] お知らせの分類の一覧。０件の場合あり。
   * branches?: string[]
   * @returns
   */
  static getMessage = async (
    txtKbn: string,
    arrayTxtKbn: string[],
    branches?: string[]
  ) => {
    return await yamadumiApi.get<HomeMessageResponse>('/api/common/message/list', {
      txtKbn,
      arrayTxtKbn,
      branches
    })
  }

  /**
   * @description メッセージ取得  ----全メッセージ取得
   *
   */
  static getAllMessages = async () => {
    return await yamadumiApi.get<HomeMessageResponse>(
      '/api/common/message/list/all'
    )
  }

  /**
   * @description メッセージ取得----------費目取得
   * @param params supplierCd 業者コード
   * @returns expenseList 費目一覧
   */
  static getHomeExpense = async (supplierCd: string) => {
    return await yamadumiApi.get<GetHomeExpenseResponse>('/api/common/message/expense', {
      supplierCd
    })
  }
}
